<div class="onboarding-stapper" id="stapper">
  <div class="onboarding-stapper__inner section-wrapper"
    [class.no-btns]="currentStep + 1 === steps.length && ownCheckout" [class.disable-interaction]="!ownCheckout">
    <div class="onboarding-stapper__summary" *ngIf="showStepSummary && currentStep !== null && steps[currentStep]">
      STEP {{ currentStep + 1 }} OF {{ steps.length }} - {{ getStepSummaryLabel(steps[currentStep]) | uppercase }}
    </div>
    <div class="onboarding-stapper__inner-scroll">
      <div class="onboarding-stapper__item" 
        *ngFor="let step of steps; let i = index;"
        (click)="checknGo(step)"
        [class.is-done]="step.isComplited && !currentUrl.includes(step.path)"
        [class.is-active]="currentUrl.includes(step.path)"
        [class.is-disabled]="!step.isComplited && !currentUrl.includes(step.path)">
  
        <i *ngIf="i" class="app-ico app-ico__bread-arrow"></i>
        <i *ngIf="step.isComplited && !currentUrl.includes(step.path)" class="app-ico app-ico__bread-checked"></i>
        <i *ngIf="!step.isComplited || currentUrl.includes(step.path)" [class.active]="currentUrl.includes(step.path)" class="ico-step">{{ i + 1 }}</i>
        
        {{ step.label }}
      </div>
    </div>
    <div class="onboarding-stapper__btns" *ngIf="(currentStep +1) < steps.length && ownCheckout">
      <div class="is-btn is-btn__outfill" (click)="prevStep()">
        <i class="app-ico-mask app-ico-mask__btn-arrow-left"></i><span>{{ 'Common.Back' | translate }}</span>
      </div>
      <div class="is-btn" (click)="nextStep()" [class.is-blocked]="isDisableStep || (stepInProgress$ | async)">
        <span class="round-loader is-trans" *ngIf="stepInProgress$ | async"></span>
        <span *ngIf="(stepInProgress$ | async) === false">{{ 'Common.Next' | translate }}</span><i *ngIf="(stepInProgress$ | async) === false" class="app-ico-mask app-ico-mask__btn-arrow-right"></i>
      </div>
   
    </div>
    <div class="onboarding-stapper__btns" *ngIf="!ownCheckout">
      <!-- <div class="is-btn is-btn__outfill" (click)="prevStep()">
        <i class="app-ico-mask app-ico-mask__btn-arrow-left"></i><span>{{ 'Common.Back' | translate }}</span>
      </div> -->
      <div class="is-btn"
        *ngIf="(currentStep + 1) < steps.length"
        [class.is-blocked]="isDisableStep || (stepInProgress$ | async)"
        (click)="nextStep()">
        <span class="round-loader is-trans" *ngIf="stepInProgress$ | async"></span>
        <span>{{ 'Common.Next' | translate }}</span>
        <i class="app-ico-mask app-ico-mask__btn-arrow-right"></i>
      </div>
      <div class="is-btn is-blocked"
        *ngIf="(currentStep + 1) === steps.length"
        [class.is-blocked]="stepInProgress$ | async"
        (click)="finishStep()">
        <span class="round-loader is-trans" *ngIf="stepInProgress$ | async"></span>
        <span>{{ 'Onboarding.CompleteSignUp' | translate }}</span>
      </div>
    </div>
  </div>
</div>
